var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "inherit",
    id: "shop-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 40,
    height: 28,
    rx: 2,
    ry: 2,
    stroke: "none",
    fill: "inherit"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "     M10 20      Q 12 16, 14 20      Q 16 24, 18 20      Q 20 16, 22 20      Q 24 24, 26 20      Q 28 16, 30 20      Q 32 24, 34 20      Q 36 16, 38 20      Q 40 24, 42 20      Q 44 16, 46 20      Q 48 24, 50 20      Q 52 16, 54 20      L 54 22      L 10 22      Z   ",
    fill: "inherit"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 36h16c0.6 0 1 0.4 1 1v10c0 0.6-0.4 1-1 1H24c-0.6 0-1-0.4-1-1V37c0-0.6 0.4-1 1-1z",
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 36v-2c0-2.2 1.8-4 4-4s4 1.8 4 4v2",
    stroke: "none",
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 42c-1.5-2-4-1-4 1s3 3.5 4 4c1-0.5 4-2 4-4s-2.5-3-4-1z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.72ecaf7aed819485a492596fbc65588f.svg";
export { ForwardRef as ReactComponent };